<template>
  <BaseTemplate>
    <div class="complete-password-reissue">
      <Title eng="COMPLATE" :jpn="t('仮パスワード送信完了')" />
      <div class="description">
        <span class="text">{{t('仮のパスワードをご登録のメールアドレスへ')}}</span>
        <span class="text">{{t('送信いたしました。')}}</span>
        <span class="text">{{t('メールを受信してご確認ください。')}}</span>
      </div>
      <BlackGradationButton
        class="square-button"
        :text="t('ログインへ戻る')"
        @handleSquareBtnClick="goToUserLogin"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CompletePasswordReissue',
  mixins: [t],

  beforeRouteLeave(to, from, next) {
    if (to.name === 'PasswordReissue') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    Title,
    BlackGradationButton,
  },

  methods: {
    goToUserLogin() {
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
.complete-password-reissue{
  width: 100%;
  max-width: 680px;
  min-height: 100%;
  padding: 70px 30px 0;
  margin: 0 auto;
  text-align: center;
  .description{
    display: flex;
    flex-direction: column;
    height: 67px;
    margin-top: 40px;
    .text{
      font-family: $notoSans;
      font-size: 14px;
      line-height: 23.4px;
      color: #000;
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 40px auto 0px;
  }
}
</style>
